var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOwnerTickS(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2933 9.29325L11.0003 12.5863L9.70725 11.2933C9.31625 10.9023 8.68425 10.9023 8.29325 11.2933C7.90225 11.6843 7.90225 12.3163 8.29325 12.7073L10.2933 14.7073C10.4883 14.9023 10.7443 15.0002 11.0003 15.0002C11.2563 15.0002 11.5123 14.9023 11.7073 14.7073L15.7073 10.7072C16.0983 10.3162 16.0983 9.68425 15.7073 9.29325C15.3163 8.90225 14.6842 8.90225 14.2933 9.29325Z",
    fill: "#00A653"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnerTickS);
export default __webpack_public_path__ + "static/media/owner_tick_s.6e0392773ed6cb7236cbe4d24f4090c2.svg";
export { ForwardRef as ReactComponent };